import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-add-quantity-popup',
  standalone: false,
  templateUrl: './add-quantity-popup.html',
  styleUrl: './add-quantity-popup.scss'
})
export class AddQuantityPopup {
  quantity: number = 1;

  constructor(
    private readonly dialogRef: MatDialogRef<AddQuantityPopup>,
    @Inject(MAT_DIALOG_DATA) public data: { binderId: number }
  ) {}

  close(): void {
    this.dialogRef.close(null);
  }

  confirmAdd(): void {
    if (!this.quantity || this.quantity <= 0) {
      return;
    }
    this.dialogRef.close(this.quantity);
  }
}
